
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { Comparator } from '@/ui-kit/enums';
import routes from '@/constants/routes';
import Paper from '@/ui-kit/components/paper';
import Gutter from '@/ui-kit/components/gutter';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Typography from '@/ui-kit/components/typography';
import { ImageSize } from './enums';

export default {
  name: 'HomeFeaturedInInfo',
  components: {
    Paper,
    Gutter,
    LazyImage,
    Typography,
  },
  mixins: [WindowSize],
  props: {
    icon: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      routes,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
      ImageSize,
      TypographyType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.icon.dimensions);
    },
    iconBoxImageSizes() {
      return [
        {
          comparator: Comparator.Greater,
          breakpoint: this.breakpoints.Small,
          imageSize: ImageSize.Default,
        },
      ];
    },
  },
};
